import AutoModeIcon from '@mui/icons-material/AutoMode';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

/**
 * Shared visual language for flow triggers in the workflow canvas and dialogs.
 */
export const getTriggerVisualConfig = (triggerMode) => {
  if (triggerMode === 'time') {
    return {
      icon: AutoModeIcon,
      iconColor: '#2e7d32',
      borderColor: 'rgba(46, 125, 50, 0.42)',
      background: 'linear-gradient(135deg, #ffffff 0%, #f1f8e9 100%)',
      iconBackground: 'linear-gradient(135deg, rgba(76, 175, 80, 0.2) 0%, rgba(102, 187, 106, 0.1) 100%)',
      shadow: '0 6px 20px rgba(76, 175, 80, 0.22), inset 0 1px 2px rgba(255, 255, 255, 0.55)',
      hoverShadow: '0 10px 26px rgba(76, 175, 80, 0.3), 0 4px 10px rgba(76, 175, 80, 0.16)',
      labelColor: '#2e7d32',
      labelBackground: 'rgba(76, 175, 80, 0.1)',
      labelBorder: 'rgba(76, 175, 80, 0.26)'
    };
  }

  if (triggerMode === 'calendar') {
    return {
      icon: CalendarMonthIcon,
      iconColor: '#8a5b00',
      borderColor: 'rgba(138, 91, 0, 0.38)',
      background: 'linear-gradient(135deg, #ffffff 0%, #fff8e6 100%)',
      iconBackground: 'linear-gradient(135deg, rgba(255, 193, 7, 0.22) 0%, rgba(255, 224, 130, 0.12) 100%)',
      shadow: '0 6px 20px rgba(255, 193, 7, 0.18), inset 0 1px 2px rgba(255, 255, 255, 0.55)',
      hoverShadow: '0 10px 24px rgba(255, 193, 7, 0.26), 0 4px 10px rgba(255, 193, 7, 0.12)',
      labelColor: '#8a5b00',
      labelBackground: 'rgba(255, 193, 7, 0.12)',
      labelBorder: 'rgba(255, 193, 7, 0.26)'
    };
  }

  if (triggerMode === 'event_confirmed') {
    return {
      icon: CheckCircleOutlineIcon,
      iconColor: '#2e7d32',
      borderColor: 'rgba(46, 125, 50, 0.38)',
      background: 'linear-gradient(135deg, #ffffff 0%, #f3faf4 100%)',
      iconBackground: 'linear-gradient(135deg, rgba(46, 125, 50, 0.18) 0%, rgba(102, 187, 106, 0.09) 100%)',
      shadow: '0 6px 18px rgba(46, 125, 50, 0.18), inset 0 1px 2px rgba(255, 255, 255, 0.55)',
      hoverShadow: '0 10px 24px rgba(46, 125, 50, 0.26), 0 4px 10px rgba(46, 125, 50, 0.12)',
      labelColor: '#2e7d32',
      labelBackground: 'rgba(46, 125, 50, 0.09)',
      labelBorder: 'rgba(46, 125, 50, 0.24)'
    };
  }

  if (triggerMode === 'event_change') {
    return {
      icon: CheckCircleOutlineIcon,
      iconColor: '#6a1b9a',
      borderColor: 'rgba(106, 27, 154, 0.36)',
      background: 'linear-gradient(135deg, #ffffff 0%, #faf5ff 100%)',
      iconBackground: 'linear-gradient(135deg, rgba(156, 39, 176, 0.18) 0%, rgba(186, 104, 200, 0.09) 100%)',
      shadow: '0 6px 18px rgba(156, 39, 176, 0.18), inset 0 1px 2px rgba(255, 255, 255, 0.55)',
      hoverShadow: '0 10px 24px rgba(156, 39, 176, 0.26), 0 4px 10px rgba(156, 39, 176, 0.12)',
      labelColor: '#6a1b9a',
      labelBackground: 'rgba(156, 39, 176, 0.09)',
      labelBorder: 'rgba(156, 39, 176, 0.24)'
    };
  }

  if (triggerMode === 'disabled') {
    return {
      icon: PauseCircleOutlineIcon,
      iconColor: '#6d6d6d',
      borderColor: 'rgba(125, 125, 125, 0.35)',
      background: 'linear-gradient(135deg, #ffffff 0%, #f3f4f6 100%)',
      iconBackground: 'linear-gradient(135deg, rgba(117, 117, 117, 0.18) 0%, rgba(158, 158, 158, 0.08) 100%)',
      shadow: '0 3px 12px rgba(117, 117, 117, 0.16), inset 0 1px 2px rgba(255, 255, 255, 0.55)',
      hoverShadow: '0 8px 18px rgba(117, 117, 117, 0.24), 0 3px 8px rgba(117, 117, 117, 0.14)',
      labelColor: '#616161',
      labelBackground: 'rgba(117, 117, 117, 0.1)',
      labelBorder: 'rgba(117, 117, 117, 0.25)'
    };
  }

  return {
    icon: PlayArrowIcon,
    iconColor: '#1565c0',
    borderColor: 'rgba(21, 101, 192, 0.4)',
    background: 'linear-gradient(135deg, #ffffff 0%, #f1f7ff 100%)',
    iconBackground: 'linear-gradient(135deg, rgba(33, 150, 243, 0.2) 0%, rgba(100, 181, 246, 0.1) 100%)',
    shadow: '0 6px 20px rgba(33, 150, 243, 0.2), inset 0 1px 2px rgba(255, 255, 255, 0.55)',
    hoverShadow: '0 10px 24px rgba(33, 150, 243, 0.3), 0 4px 10px rgba(33, 150, 243, 0.14)',
    labelColor: '#1565c0',
    labelBackground: 'rgba(33, 150, 243, 0.1)',
    labelBorder: 'rgba(33, 150, 243, 0.24)'
  };
};
